/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Closedeal_Summary_Openorders3Inputs */

const en_coinvestments_closedeal_summary_openorders3 = /** @type {(inputs: Coinvestments_Closedeal_Summary_Openorders3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisations with open indicative orders`)
};

/**
* | output |
* | --- |
* | "Organisations with open indicative orders" |
*
* @param {Coinvestments_Closedeal_Summary_Openorders3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_closedeal_summary_openorders3 = /** @type {((inputs?: Coinvestments_Closedeal_Summary_Openorders3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Closedeal_Summary_Openorders3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_closedeal_summary_openorders3(inputs)
});
export { coinvestments_closedeal_summary_openorders3 as "coInvestments_closeDeal_summary_openOrders" }